import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import { Trans } from 'helpers/i18n';
import Row, { Col } from 'components/row';

import 'styles/domik/section-terms/_page-terms.scss';

const bemClasses = new Bem('pageTerms');

export default class DocRulesPublishingDisplayAd extends Component {
  static propTypes = {
    blockRef: PropTypes.func,
    blockId: PropTypes.string
  };

  render() {
    const { blockRef, blockId } = this.props;

    return (
      <div
        {...bemClasses('section', 'rulesPublishingDisplayAd')}
        ref={blockRef}
        id={blockId}
      >
        <Trans lang="ru">
          <Row {...bemClasses('rowTopic')} mpColumn>
            <Col allPr={0}>
              <div {...bemClasses('text', 'h2')}>
                <h2 children="Правила публикации медийных объявлений" />
              </div>
            </Col>
          </Row>
          <div {...bemClasses('text')}>
            <p>Пользователь разместивший медийное объявление, несет ответственность за достоверность информации. В случае, если в адрес domik.ua будут направлены жалобы, претензии, поданы иски со стороны третьих лиц либо применены иные меры принудительного характера, в связи с размещением на сайте domik.ua информации, нарушающей права третьих лиц, ー всю ответственность, в том числе имущественную, несет лицо, разместившее объявление.</p>
            <p>Пользователь, размещающий медийное объявление, обязуется придерживаться следующих правил:</p>
          </div>
          <ol {...bemClasses('ol', 'list')}>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')}>Заголовок объявления</span>
              <ul {...bemClasses('ul', 'hyphen')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Заголовки должны быть связными, читаемыми и соответствовать содержанию объявления." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Заголовки не должны содержать контактных данных и ссылок." />
                  <div {...bemClasses('text')} children="Все эти данные добавляются в соответствующие поля медийного объявления." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Текст заголовка объявления не должен быть составлен с использованием верхнего регистра, за исключением первых букв заглавных слов и имен собственных. Целиком в верхнем регистре могут быть написаны только аббревиатуры. Пример НЕправильного написания: «СРОЧНО ПРОДАМ ПОМЕЩЕНИЕ»." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Заголовок объявления не должен содержать повторяющиеся восклицательные и вопросительные знаки, многоточия, а также другие символы." />
                  <div {...bemClasses('text')} children="Пример НЕправильного написания: «***Сдам квартиру, дешево!!!»." />
                </li>
              </ul>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')}>Изображение</span>
              <ul {...bemClasses('ul', 'hyphen')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Изображение, сопровождающее объявление, должно иметь очевидную смысловую связь с текстом объявления и адекватно иллюстрировать текст объявления." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Размещаемые в объявлениях изображения должны быть высокого качества, без меток и надписей." />
                </li>
              </ul>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')}>Содержание объявления</span>
              <ul {...bemClasses('ul', 'hyphen')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Ответственность за содержание объявлений несут Пользователи, которые их подали." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Не стоит вводить в заблуждение потенциальных клиентов, размещая объявления о несуществующих объектах недвижимости, товарах, услугах. Такие действия будут причиной негативного отзыва." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Запрещается вводить текстовую информацию исключительно заглавными буквами. Это плохо читается." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Описание не должно содержать контактных данных и ссылок. Все эти данные добавляются в соответствующие поля медийного объявления." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Мы не приветствуем рекламу об услугах, предоставляемых конкурентами Портала, как-то, но не исключительно: информацию о сайтах недвижимости, форумах недвижимости, других конкурентных интернет-ресурсах." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Запрещено использовать в объявлениях на Портале текст, изображения и иные материалы, если Пользователь не является автором или правообладателем этих материалов." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Мы не публикуем объявления о реализации запрещенных законодательством Украины товаров и услуг." />
                </li>
              </ul>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')}>Ссылка в объявлении</span>
              <ul {...bemClasses('ul', 'hyphen')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Ссылка в объявлении должна вести на ресурс, который подробнее рассказывает о рекламируемом товаре или услуге." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="В связи с тем, что ресурс, на который ведет опубликованная в объявлении ссылка является продолжением рекламного объявления, к нему применяются все требования к содержанию медийных объявлений данного документа." />
                </li>
              </ul>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')}>Проверка объявлений</span>
              <ul {...bemClasses('ul', 'hyphen')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Все объявления, размещаемые пользователями Портала проходят проверку перед публикацией." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Администратор вправе отклонить объявление, если оно нарушает правила публикации медийных объявлений." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="После проверки объявления, на вашу электронную почту отправляется письмо с информацией о результате проверки." />
                </li>
              </ul>
            </li>
          </ol>
        </Trans>
        <Trans lang="ua">
          <Row {...bemClasses('rowTopic')} mpColumn>
            <Col allPr={0}>
              <div {...bemClasses('text', 'h2')}>
                <h2 children="Правила публікації медійних оголошень" />
              </div>
            </Col>
          </Row>
          <div {...bemClasses('text')}>
            <p>Користувач, який розмістив медійне оголошення, несе відповідальність за достовірність інформації. У випадку, якщо на адресу domik.ua будуть направлені скарги, претензії, подані позови з боку третіх осіб або застосовані інші заходи примусового характеру, у зв'язку з розміщенням на сайті domik.ua інформації, що порушує права третіх осіб, - відповідальність числі майнову, несе особа, яка розмістила оголошення.</p>
            <p>Користувач, який розміщує медійне оголошення, зобов'язується дотримуватися таких правил:</p>
          </div>
          <ol {...bemClasses('ol', 'list')}>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')}>Заголовок оголошення</span>
              <ul {...bemClasses('ul', 'hyphen')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Заголовки повинні бути зв'язковими, читаними та відповідати змісту оголошення." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Заголовки не повинні містити контактних даних та посилань." />
                  <div {...bemClasses('text')} children="Всі ці дані додаються до відповідних полів медійного оголошення." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Текст заголовка оголошення не повинен бути складений з використанням верхнього регістру, за винятком перших літер великих слів та власних назв. Цілком у верхньому регістрі можуть бути написані лише абревіатури. Приклад НЕправильного написання: «ТЕРМІНОВО ПРОДАМ ПРИМІЩЕННЯ»." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Заголовок оголошення не повинен містити повторення знаків оклику та питання, крапки, а також інші символи." />
                  <div {...bemClasses('text')} children="Приклад НЕправильного написання: «***Здам квартиру, дешево!!!»." />
                </li>
              </ul>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')}>Зображення</span>
              <ul {...bemClasses('ul', 'hyphen')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Зображення, що супроводжує оголошення, повинно мати очевидний змістовий зв’язок із оголошенням та адекватно ілюструвати текст оголошення." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Зображення, що розміщуються в оголошеннях, повинні бути високої якості, без міток і написів." />
                </li>
              </ul>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')}>Зміст оголошення</span>
              <ul {...bemClasses('ul', 'hyphen')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Відповідальність за зміст оголошень несуть Користувачі, які їх подали." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Не варто вводити в оману потенційних клієнтів, розміщуючи оголошення про неіснуючі об'єкти нерухомості, товари, послуги. Такі дії будуть причиною негативного відгуку." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Забороняється вводити текстову інформацію виключно великими літерами. Це погано читається." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Опис не повинен містити контактних даних та посилань. Всі ці дані додаються у відповідні поля медійного оголошення." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Ми не вітаємо рекламу про послуги, що надаються конкурентами Порталу, як то, але не виключно: інформацію про сайти нерухомості, форуми нерухомості, інші конкурентні інтернет-ресурси." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Заборонено використовувати в оголошеннях на Порталі текст, зображення та інші матеріали, якщо Користувач не є автором чи правовласником цих матеріалів." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Ми не публікуємо оголошення про реалізацію заборонених законодавством України товарів та послуг." />
                </li>
              </ul>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')}>Посилання в оголошенні</span>
              <ul {...bemClasses('ul', 'hyphen')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Посилання в оголошенні має вести на ресурс, який детальніше розповідає про товар або послугу, що рекламується." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="У зв'язку з тим, що ресурс, на який веде опубліковане в оголошенні посилання, є продовженням рекламного оголошення, до нього застосовуються всі вимоги до змісту медійних оголошень цього документа." />
                </li>
              </ul>
            </li>
            <li {...bemClasses('li')}>
              <span {...bemClasses('text', 'bold')}>Перевірка оголошень</span>
              <ul {...bemClasses('ul', 'hyphen')}>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Всі оголошення, розміщені користувачами Порталу, проходять перевірку перед публікацією." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Адміністратор може відхилити оголошення, якщо воно порушує правила публікації медійних оголошень." />
                </li>
                <li {...bemClasses('li')}>
                  <span {...bemClasses('text')} children="Після перевірки оголошення, на вашу електронну пошту надсилається лист з інформацією про результат перевірки." />
                </li>
              </ul>
            </li>
          </ol>
        </Trans>
      </div>
    );
  }
}
